import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchMotivosRechazo, useUpdateMotivoRechazo } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { MotivoRechazo } from '@/shared/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { PermissionsEnum } from '@/auth/interfaces';

const returnUrlMotivoRechazo = '/parametrizacion/motivo-rechazo';

export interface MotivoRechazoPageInterface {}

const MotivoRechazoPage: React.FC<MotivoRechazoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_motivorechazo)
  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* fetch data
  const {
    data: MotivoRechazoPagingRes,
    isLoading,
    isRefetching,
  } = useFetchMotivosRechazo({
    page: pageIndex + 1,
    nombre: searchTerm,
    page_size: 600,
  });

  ///* handlers
  const onEdit = (original:MotivoRechazo) => {
    navigate(`${returnUrlMotivoRechazo}/editar/${original.id_motivo_rechazo}`);
  };
  const updateMotivo = useUpdateMotivoRechazo({
    navigate,
    returnUrl:returnUrlMotivoRechazo,
  }
  )
  ///* columns
  const columns = useMemo<MRT_ColumnDef<MotivoRechazo>[]>(
    () => [
    
      {
        accessorKey: 'numero_referencia',
        header: 'Numero referencia',
        size: 90,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'modulo',
        header: 'Modulo',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={dep => {
              if (!hasPermission(PermissionsEnum.api_change_motivorechazo)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateMotivo.mutate({
                    id: row.original.id_motivo_rechazo!,
                    data: {
                      ...row.original,
                      estado: dep as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Motivos de rechazo" urlRedirect={`${returnUrlMotivoRechazo}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_motivorechazo)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Motivos de rechazo" />

      <GeneralTable<MotivoRechazo>
        columns={columns}
        data={MotivoRechazoPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={MotivoRechazoPagingRes?.data?.count}
        // // actions
        enableColumnActions={hasPermission(PermissionsEnum.api_change_motivorechazo)}
        // crud
        onEdit={onEdit}
        canEdit={hasPermission(PermissionsEnum.api_change_motivorechazo)}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default MotivoRechazoPage;
